import { TableIds } from '../../../../../enums/tableIds'

export const getTrackingEvents = (tableId: string) => {
  const eventMap = {
    [TableIds.ExternalInvoicesList]: {
      rowClicked: 'XXX - Invoicing Core - Invoices List - Table row clicked',
      showVoidedClicked: 'XXX - Invoicing Core - Invoices List - Show voided checkbox clicked',
    },
    [TableIds.ClientExternalInvoicesList]: {
      rowClicked: '',
      showVoidedClicked: '',
    },
  } as const

  return eventMap[tableId]
}
